import tw from "twin.macro";

const Panel = tw.div`p-2`;
export default Panel;

export const SearchFormPanel = tw.div`mb-8`;

export const HeaderPanel = tw.div`pt-10`;
